<script setup lang="ts">
import BaseAutoComplete from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import courseType from 'src/types/responses/course';
import Api from '@/services/api/ApiServiceFabrick';
import { ref, computed, onMounted } from 'vue';

const emit = defineEmits<{
  (e: 'update:modelValue', value: courseType): void
}>();

const props = defineProps<{
  modelValue: courseType;
  operationOfficeId: number;
  initialId: number | null;
  label: string;
}>();

const courses = ref<courseType[]>([]);
const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

onMounted(() => {
  Api()
    .getCourses(props.operationOfficeId)
    .then((data: courseType[]) => {
      courses.value = data;
      if (props.initialId) {
        const foundCourse = courses.value.find((course: courseType) => {
          return course.id === props.initialId;
        });
        if (foundCourse) {
          modelValue.value = foundCourse;
        }
      }
    });
})
</script>
<template>
  <BaseAutoComplete
    v-model="modelValue"
    :label="props.label"
    itemName="name"
    :items="courses"
  />
</template>
